import { render, staticRenderFns } from "./dialogToken.vue?vue&type=template&id=0a782bf2&scoped=true&"
import script from "./dialogToken.vue?vue&type=script&lang=js&"
export * from "./dialogToken.vue?vue&type=script&lang=js&"
import style0 from "./dialogToken.vue?vue&type=style&index=0&id=0a782bf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a782bf2",
  null
  
)

export default component.exports